import { MembershipWithOrganizationTypeEnum } from '@/api/rest/resources/types/membership';
import { paths } from '@/routing';

import { useIsStaffUser } from './useIsStaffUser';
import { useMembershipType } from './useMembershipType';

export const usePathSet = (inputMembershipType?: MembershipWithOrganizationTypeEnum) => {
  const isStaffUser = useIsStaffUser();

  const membershipTypeFallback = useMembershipType();
  const membershipType = inputMembershipType ?? membershipTypeFallback;

  if (isStaffUser) {
    return paths.staff;
  }

  return membershipType === MembershipWithOrganizationTypeEnum.land_steward ? paths.landSteward : paths.buyer;
};
